import { PickRequired } from "@/utils/types";
import { ValidationResponse } from "@/api";

export const enum ControlStatus {
  INCOMPLETE = "incomplete",
  REVIEW = "review",
  COMPLETE = "complete",
  INCORRECT = "incorrect",
  ERROR = "error",
}

export const enum BoxStatus {
  INCOMPLETE = "incomplete",
  REVIEW = "review",
  COMPLETE = "complete",
}

export type TextValidation = PickRequired<ValidationResponse> & Pick<ValidationResponse, "text">;
export type UploadValidation = PickRequired<ValidationResponse> & Pick<ValidationResponse, "file">;
// TODO change this once we want to start saving more url specific fields like extension etc.
export type UrlValidation = PickRequired<ValidationResponse> & Pick<ValidationResponse, "text">;
